var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9248 8.16158C24.8266 8.16158 27.4587 9.84701 28.9594 11.2554L34.8238 5.52955C31.222 2.18179 26.5352 0.126953 20.9248 0.126953C12.7978 0.126953 5.77903 4.79073 2.36201 11.5786L9.08062 16.7965C10.766 11.7864 15.4298 8.16158 20.9248 8.16158Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8728 21.3679C40.8728 19.6594 40.7343 18.4127 40.4341 17.1197H20.9247V24.8311H32.3764C32.1455 26.7474 30.8988 29.6334 28.1282 31.5728L34.6852 36.6522C38.6102 33.0274 40.8728 27.694 40.8728 21.3679Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10366 25.0158C8.66499 23.7229 8.41102 22.3376 8.41102 20.9061C8.41102 19.4747 8.66504 18.0894 9.08062 16.7965L2.36201 11.5786C0.953638 14.3953 0.145508 17.5584 0.145508 20.9061C0.145508 24.2539 0.953588 27.4169 2.36196 30.2337L9.10366 25.0158Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9247 41.6853C26.5351 41.6853 31.2451 39.8383 34.6852 36.6522L28.1282 31.5728C26.3735 32.7965 24.0185 33.6507 20.9247 33.6507C15.4297 33.6507 10.766 30.0259 9.10366 25.0158L2.385 30.2336C5.80203 37.0215 12.7977 41.6853 20.9247 41.6853Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColored);
export default __webpack_public_path__ + "static/media/googleColored.bc257e97809cc92e84aa350fa5c100f5.svg";
export { ForwardRef as ReactComponent };